import { setDeviceDataInLocal } from '../layouts/dashboard/header/services';
import { setLocalSelectedDevice } from './selectedDevice';

export const handleSelectPrimaryDevice = async (getMainDevice, handleCloseToast) => {
  const { data, error } = await getMainDevice({
    context: {
      uri: process.env.REACT_APP_GRAPHQL_URI,
    },
  });

  if (!error) {
    setLocalSelectedDevice({ ...data.devices.me, isPrimary: true });
    setDeviceDataInLocal(data, 'me');
    handleCloseToast();
    window.location.reload();
  }
};
